import { t } from "@lingui/macro";
import * as v from "valibot";
import type { Permission } from "~/models/permission";

export const key = "artist.create";

export const permissions: Array<Permission | RegExp> = ["Artist.Create"];

export const Schema = () =>
  v.object({
    labelUid: v.optional(v.string(t`The label ID must be a string.`)),
    forCollaborator: v.optional(
      v.string(t`The collaborator ID must be a string.`),
    ),
  });
